import PropTypes from 'prop-types';
import Dialog from "components/ui/Dialog/Dialog";
import { useEffect, useState } from "react";
import useData from "hooks/useData";
import Button from "components/ui/Button/Button";
import { useDialog } from "context/DialogContext";
import { useHistory, useLocation } from "react-router-dom";

const BulletinActionUnsubscribe = ({ entity_id }) => {
  const history = useHistory();
  const location = useLocation();
  const { deleteData } = useData();
  const { hideDialog } = useDialog();
  const [ message, setMessage ] = useState();
  const [ error, setError ] = useState();

  const handleClose = () => {
    history.push(location.pathname);
    hideDialog();
  }

  useEffect(
    () => {
      const performUnsubscribe = async () => {
        const response = await deleteData(`rest/bulletin/${ entity_id }/follow`);
        switch (response?.status) {
          case 204:
            setMessage('Gelukt, u zult van dit bericht geen e-mails meer ontvangen.');
            break;

          case 200:
            setMessage('U was al afgemeld, u ontvangt van dit bericht geen e-mails meer.');
            break;

          default:
            setError(`Het is niet gelukt om u af te melden, probeer het later opnieuw of neem contact op met de ledenservice als dit probleem blijft bestaan. (${ response?.status })`);
            break;
        }
      }
      performUnsubscribe();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ entity_id ]);

  return (
    <Dialog title={ `Afmelden e-mail notificaties` }
            errorMessage={ error }
            loading={ !error && !message }>
      <div className={ `dialog__row` }>
        { message }
      </div>
      <div className="dialog__buttons dialog__buttons--end">
        <Button variant={ `secondary` } onClick={ handleClose }>Sluiten</Button>
      </div>
    </Dialog>
  )
}

BulletinActionUnsubscribe.propTypes = {
  entity_id: PropTypes.number.isRequired,
}

export default BulletinActionUnsubscribe;
